import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from "@angular/core";
import { Location } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";
import { ProductsListBase } from "../products-list-base";
import { DataTableService, CreateOfferDataService, AuthenticationService, ProductService, SalesOrderDataService } from "src/app/_services";
import { IProductsSearchFormData } from "../../product/product-info/product-info.model";
import { UserAction, HttpMethod, LxmAppModule } from "src/app/enum";
import { ProductsRetailerExportDialogComponent } from "../retailer/export-products-retailer.dialog";
import { LxmDialog, LxmMessage } from "src/app/_helpers";
import { catchError, map, mergeMap } from "rxjs/operators";
import { ProductsListState } from "../products-list.state";
import { FormDatePipe } from "src/app/pipes";
import { TranslateService } from "@ngx-translate/core";
import { AppState } from "src/app/state/app.state";
import { ConformityDeclarationDialog } from "src/app/dialogs/conformity-declaration/conformity-declaration.dialog";
import {
  ConfirmedProductsReportDialog,
  IConfirmedProductsReportDialogResult
} from "src/app/dialogs/confirmed-products-report/confirmed-products-report.dialog";
import { SendProductImagesDialog } from "src/app/dialogs/send-product-images/send-product-images.dialog";
import { EMPTY } from "rxjs";

@Component({
  selector: "products-supplier-card",
  templateUrl: "./products-supplier.card.html",
  host: { class: "data-table-card" },
  styleUrls: ["./products-supplier.card.scss", "../products-list-base.scss"]
})
export class ProductsSupplierCard extends ProductsListBase<ISupplierProductData, any> implements OnInit {

  @ViewChild('download') private _download: ElementRef;

  dataUrl = "products/forSupplier";
  method = HttpMethod.Post;
  initialData;

  public formData: IProductsSearchFormData;

  public table = {
    columns: []
  };

  protected colPropertyMap = {
    'product_name': 'fullName',
    'product_brand': 'brand',
    'conformity_state': 'isConformityConfirmed'
  };

  public UserAction = UserAction;
  public LxmAppModule = LxmAppModule;

  constructor(
    private _productService: ProductService,
    private _router: Router,
    private _createOfferDataService: CreateOfferDataService,
    private _formDate: FormDatePipe,
    private _translateService: TranslateService,
    private _message: LxmMessage,
    public soDataService: SalesOrderDataService,
    public appState: AppState,
    public state: ProductsListState,
    authService: AuthenticationService,
    location: Location,
    public dialog: LxmDialog,
    route: ActivatedRoute,
    dataTableService: DataTableService<ISupplierProductData, any>,
    cd: ChangeDetectorRef
  ) {
    super(state, location, dialog, dataTableService, cd);
    this.initialData = route?.snapshot?.data?.initialData;
    this.formData = route?.snapshot?.data?.formData as IProductsSearchFormData;
    this.message = _message;

    let cols = [
      "product_select",
      "product_image",
      "product_name",
      // "product_ean",
      "product_brand",
      // "product_tree"
    ];

    if (
      authService.hasModule(LxmAppModule.ConformityDeclarations) &&
      authService.hasRight([UserAction.ViewConformityDeclarations])
    ) {
      cols.push("conformity_state");
    }

    if (authService.hasRight([UserAction.ViewPrices])) {
      cols = cols.concat(
        this.formData.retailChains
          .sort((a, b) => (a.shortName > b.shortName ? 1 : -1))
          .map((x) => x.id)
      );
    }

    this.table.columns = cols;
  }

  public get isCreateConformityDeclarationVisible() {
    return this.appState.hasModule(LxmAppModule.ConformityDeclarations) &&
      this.appState.hasRights([UserAction.ManageConformityDeclarations]) &&
      (this.formData.conformityDeclarationTypes?.length > 0 || this.formData.conformityDeclarationConfirmedTypes?.length > 0);
  }

  public get isConfirmedProductsReportVisible() {
    return this.appState.hasModule(LxmAppModule.ConformityDeclarations) &&
      this.appState.hasRight([UserAction.GenerateConfirmedProductsReport]);
  }

  public get canCreateConformityDeclaration() {
    const productsConfirmed = this.selection.every((x) => x.isConformityConfirmed);
    return this.appState.hasModule(LxmAppModule.ConformityDeclarations) &&
      this.appState.hasRights([UserAction.ManageConformityDeclarations]) &&
      (
        this.formData.conformityDeclarationTypes?.length > 0 ||
        (productsConfirmed && this.formData.conformityDeclarationConfirmedTypes?.length > 0)
      );
  }


  public getProductValidationUrl(productId: string, retailerId: string): string {

    if (!productId || !retailerId) {
      return "";
    }

    return this._router
      .createUrlTree(["/products", productId, "validate"], {
        queryParams: retailerId
          ? {
            retailerId: [retailerId]
          }
          : null
      })
      .toString();
  }

  public getRetailPriceScheme(row: ISupplierProductData, chainId: string): any {
    const name = "retailPriceScheme_" + chainId.replace(/-/g, "");
    return row.retailPriceSchemes[name];
  }

  public getRetailerHasInvalidValues(
    row: ISupplierProductData,
    retailerId: string
  ): boolean {
    return row.retailersWithInvalidValues.includes(retailerId);
  }

  public getRetailLocationAssortments(
    row: ISupplierProductData,
    chainId: string
  ): any {
    return row.retailLocationAssortments?.[chainId];
  }

  public newProduct() {
    this._router.navigate(["/products/new"]);
  }

  public createOffer() {
    this._createOfferDataService.productIds = this.selection.map((x) => x.id);
    this._router.navigate(["/offers/new"]);
  }

  public createSalesOrderFromSelection() {
    const productIds = this.selection.map((x) => x.id);
    this.soDataService.productIds = productIds;
    this._router.navigate(["orders/sales/new"]);
  }

  public export() {
    var ids = this.selection.map((x) => x.id);
    if (ids?.length == 0) {
      ids = this.dataSource?.data?.map((x: any) => x.id);
    }
    if (ids?.length > 0) {
      this.closeDotMenu.emit();
      this.dialog.open(ProductsRetailerExportDialogComponent, {
        resolve: () =>
          this._productService.exportSupplierProducts({ productIds: ids }).pipe(
            map((res) => {
              this._productService.getSupplierProductsExport(res.id);
            })
          )
      });
    }
  }

  public getImageDescription(product: ISupplierProductData) {
    const { activeViaOffer, offerActiveTo } = product || {};
    if (!activeViaOffer) return null;
    if (!offerActiveTo)
      return this._translateService.instant(
        "cards.products.product_base_info.in_active_offer_termless"
      );
    return `${this._translateService.instant("cards.products.product_base_info.in_active_offer_until")} ${this._formDate.transform(offerActiveTo)}`;
  }

  public openConformityDeclarationDialog(selection = this.selection) {
    this.closeDotMenu.emit();

    const conformityDeclarationFormats = [...this.formData.conformityDeclarationTypes];
    const productsConfirmed = selection.every((x) => x.isConformityConfirmed);

    if (productsConfirmed) {
      conformityDeclarationFormats.push(...this.formData.conformityDeclarationConfirmedTypes);
    }

    this.dialog.open(
      ConformityDeclarationDialog,
      {
        width: "700px",
        height: "auto",
        data: {
          productIds: selection.map((x) => x.id),
          contactOptions: this.formData.recipientContacts,
          selectedFormats: conformityDeclarationFormats
        }
      },
      (res) => { }
    );
  }

  public openConfirmedProductsReportDialog() {
    this.closeDotMenu.emit();

    this.dialog.open(
      ConfirmedProductsReportDialog,
      { width: "700px", height: "auto" },
      (period: IConfirmedProductsReportDialogResult) => {
        if (!period) {
          return;
        }

        this.dialog.open(ProductsRetailerExportDialogComponent, {
          resolve: () =>
            this._productService
              .exportConfirmedProductsReport(period)
              .pipe(
                mergeMap(async (res) => {
                  const blob = await this._productService
                    .downloadXls(res.id)
                    .toPromise();
                  return { fileName: res.fileName, blob: blob };
                })
              )
              .pipe(
                map((res) => {
                  const url = window.URL.createObjectURL(res.blob);
                  const link = this._download.nativeElement;
                  link.href = url;
                  link.download = res.fileName;
                  link.click();
                  window.URL.revokeObjectURL(url);
                })
              )
        });
      }
    );
  }

  public openSendProductImagesDialog(selection = this.selection) {
    this.closeDotMenu.emit();

    this.dialog.open(
      SendProductImagesDialog,
      {
        width: "700px",
        height: "auto",
        data: {
          productIds: selection.map((x) => x.id),
          contactOptions: this.formData.recipientContacts
        }
      },
      (res) => { }
    );
  }

  public downloadImages() {
    var ids = this.selection.map(x => x.id);
    this.dialog.open(ProductsRetailerExportDialogComponent, {
      resolve: () =>
        this._productService
          .exportImages(ids)
          .pipe(
            mergeMap(async (res) => {
              const blob = await this._productService
                .downloadImages(res.id)
                .toPromise();
              return {
                fileName: res.fileName,
                blob: blob
              };
            }),
            catchError((err) => {
              console.error(err);
              return EMPTY;
            })
          )
          .pipe(
            map((res) => {
              const url = window.URL.createObjectURL(res.blob);
              const link = this._download.nativeElement;
              link.href = url;
              link.download = res.fileName;
              link.click();
              window.URL.revokeObjectURL(url);
            })
          )
    });
  }
}

export interface ISupplierProductData {
  id: string;
  fullName: string;
  weight: string;
  ean: number;
  brand: string;
  segment: string;
  status: number;
  imageUrl: string;
  imageThumbUrl: string;
  imageThumbSmallUrl: string;
  retailersWithInvalidValues: string[];
  retailPriceSchemes: IRetailPriceSchemes;
  retailLocationAssortments: any;
  activeViaOffer: boolean;
  offerActiveTo: Date;
}

interface IRetailPriceSchemes {
  retailPriceScheme?: IRetailPriceScheme;
}

interface IRetailPriceScheme {
  campaign: boolean;
  campaignFrom: string;
  campaignTo: string;
  campaignInfo: any;
  mainPrice: number;
  publicPrice: number;
  retailPrice: number;
}

export interface ISupplierCompanyData {
  shops: number;
  listed_price: string;
  hasCampaign: boolean;
  campaignInfo: any;
}

export interface ISupplierInfo {
  company: string;
  as: string;
}

export interface IProductInfo {
  name: string;
  weight: string;
}
